import type { JSX, ReactNode } from 'react'

export const CopyTextState = { Idle: 'idle', Success: 'success', FadingOut: 'fading-out', Error: 'error' } as const

export type CopyTextState = (typeof CopyTextState)[keyof typeof CopyTextState]

export type CopyTextProps = {
  textToCopy: string | undefined | null
  showPreview?: boolean
  previewLabel?: ReactNode
  previewHint?: string
  children: (copyText: () => void, state: CopyTextState) => JSX.Element
  onError?: (error: Error) => void
  onTextCopied?: (text: string) => void
  className?: string
  fadeOutDelay?: number
  idleDelay?: number
}
